import React, { useState, useEffect } from 'react'
import { Provider, useSelector } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Route, Switch } from 'react-router-dom';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { basicLogger } from 'launchdarkly-js-client-sdk';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { THEME_CONFIG } from './configs/AppConfig';
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';
//import Loading from './loading';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'leaflet/dist/leaflet.css';
import { initAnalytics } from 'utils/analytics-utils';
import Utils from 'utils';
import { Environment } from 'utils/environment';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  const isProduction = process.env.NODE_ENV === 'production';
  const currentAccount = useSelector(s => s.account?.details);
  const currentUser = useSelector(s => s.user?.details);

  useEffect(() => {
    if (currentUser && Utils.getSessionToken() && currentAccount) {
      initAnalytics(currentUser, currentAccount);
    }
  }, [currentUser, currentAccount]);

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={!isProduction} //If true, the library writes verbose logs to console.
      //loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      //metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
      <div className="App"> 
        <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme}
          insertionPoint={document.getElementById('styles-insertion-point')}>
          <Router
            getUserConfirmation={() => {
              /* Empty callback to block the default browser prompt */
            }}>
            <Switch>
              <Route path="/" component={Views} />
            </Switch>
          </Router>
        </ThemeSwitcherProvider> 
      </div>
    </CacheBuster>
  );
}

export default withLDProvider({
  clientSideID: Environment.LAUNCH_DARKLY_CLIENT_KEY,
  options: {
    logger: basicLogger({ level: 'error' })
  }
})(App);

//export default App;
